import { render, staticRenderFns } from "./Educations.vue?vue&type=template&id=ad0cb2aa&"
import script from "./Educations.vue?vue&type=script&lang=ts&"
export * from "./Educations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports